import { Component } from '@angular/core';
import { RecommendationContributorContentEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Contributor Contents') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-recommendationcontributorcontent-form',
    templateUrl: './recommendationcontributorcontent.form.component.html'
})
export class RecommendationContributorContentFormComponent extends BaseFormComponent {
    public record!: RecommendationContributorContentEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

